import createModalToggle from '../../generic/create-modal-toggle';
import api from '../../REST/api';
import withApiRequest from '../../REST/with-api-request';
import { connectEditor } from '../connect-editor';
import CreateChangeRequestForm from './CreateChangeRequestForm';

const mapStateToProps = ({ campaign, campaignLinesById }) => ({
  campaign,
  campaignLinesById,
});
const ConnectedForm = connectEditor(mapStateToProps)(CreateChangeRequestForm);

const Form = withApiRequest({
  query: api.addCampaignChange,
  error: 'flash',
  successMessage: 'Change requested',
})(ConnectedForm);

export default createModalToggle(
  'Request Change',
  Form,
  {
    color: 'secondary',
    title:
      'A change can be requested for a campaign with the status "Ready for Set up" or any status after that. In order to apply changes before hand, please re-create the campaign from the updated quote.',
  },
  { size: 'xl', className: 'modal-dialog-extra-wide' },
);
